import { render, staticRenderFns } from "./MeetGreetReview.vue?vue&type=template&id=acc6ec42&"
import script from "./MeetGreetReview.vue?vue&type=script&lang=js&"
export * from "./MeetGreetReview.vue?vue&type=script&lang=js&"
import style0 from "./MeetGreetReview.vue?vue&type=style&index=0&id=acc6ec42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports